<template>
  <div>
    <div class="d-flex flex-row p2 mb-2 justify-content-between">
      <json-excel
        class="btn btn-rounded btn-primary mr-1"
        style="width: 150px"
        :fetch="activeData"
        :fields="json_fields"
        type="csv"
        worksheet="My Worksheet"
        name="MassNotificationUsers.csv"
      >
        Excel
      </json-excel>
      <div class="d-flex flex-row">
        <div class="form-outline">
          <input
            type="input"
            v-model="searchItem"
            class="form-control"
          />
        </div>
        <button
          type="button"
          @click="searchFor('active')"
          class="btn btn-primary"
        >
          <i class="fas fa-search"></i>
        </button>
      </div>
    </div>
    <div class="table-responsive">
      <table
        id="all_users_table"
        class="display table table-striped table-bordered"
        style="width: 100%; text-align: center"
      >
        <thead>
          <tr>
            <th>Name</th>
            <th>IC No.</th>
            <th>Mobile No.</th>
          </tr>
        </thead>
        <tbody>
          <tr v-show="users.length == 0">
            <td colspan="6" class="text-center">No Data.</td>
          </tr>
          <tr v-for="(user, index) in users" v-bind:key="index">
            <td>{{ user.name }}</td>
            <td>{{ user.ic_number }}</td>
            <td>{{ user.mobile_number }}</td>
          </tr>
        </tbody>
      </table>

      <pagination
        v-model="pageInfo.current_page"
        :per-page="pageInfo.per_page"
        :records="pageInfo.total"
        @paginate="handlePageChange"
      />
    </div>

    <br />
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Pagination from "vue-pagination-2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import JsonExcel from "vue-json-excel";
import { getRequest, postRequest } from "@/services/RequestService";
import { getAllEligibleUsers } from "../../../../services/MassNotificationService";

export default {
  name: "table_all_users",
  components: {
    Pagination,
    Loading,
    JsonExcel,
  },

  props: {
    massNotificationId: {
      type: [Number, String]
    }
  },

  data() {
    return {
      user: {},
      reason: "",
      users: [],
      pageInfo: {
        current_page: 1,
        next_page_url: null,
        previous_page_url: null,
        total: 0,
        count: 0,
        per_page: 0,
        last_page: 0,
      },

      isLoading: false,
      fullPage: true,
      searchItem: null,
      extraRequest: null,
      json_fields: {
        name: "name",
        "IC No": "ic_number",
        "Mobile No": "mobile_number",
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  watch: {
    users: {
      handler(newData) {
        if (newData) {
          this.isLoading = false;
        }
      },
      deep: true
    }
  },

  methods: {
    async fetchUsers(extraRequest = null) {
      try {
        const response = await getAllEligibleUsers(this.$props.massNotificationId, extraRequest);
        this.users = response.data.data.users;
        this.pageInfo = response.data.data.pagination;
      } catch (e) {
        console.log(e);
      }
    },


    async activeData() {
      this.isLoading = true;
      // clear json_data
      this.json_data = [];

      this.extraRequest = this.buildExtraRequest(null, 1);
      const response = await getAllEligibleUsers(this.$props.massNotificationId, this.extraRequest);

      for (let i = 0; i < response.data.data.users.length; i++) {
        this.json_data.push({
          name: response.data.data.users[i].name,
          ic_number: response.data.data.users[i].ic_number,
          mobile_number: response.data.data.users[i].mobile_number,
        });
      }

      this.isLoading = false;

      return this.json_data;
    },

    buildExtraRequest(page = null, exportData = null) {
      const filters = [];
      if (this.searchItem) filters.push(`search=${this.searchItem}`);
      if (exportData) filters.push(`export=${exportData}`);
      if (page) filters.push(`page=${page}`);
      return filters.length ? `?${filters.join('&')}` : null;
    },


    async handlePageChange(page) {
      this.isLoading = true;
      this.extraRequest = this.buildExtraRequest(page);
      await this.fetchUsers(this.extraRequest);
    },

    async searchFor() {
      this.isLoading = true;
      this.extraRequest = this.buildExtraRequest();
      await this.fetchUsers(this.extraRequest);
    },

  },

  beforeMount() {},

  async created() {
    await this.fetchUsers();
  },
};
</script>
